<template>
  <div>
    <component
      @close="$emit('close')"
      @toggleTab="toggleTab($event)"
      v-bind:is="currentTabComponent"
    ></component>
  </div>
</template>

<script>
import EmailInvite from '@/components/Invitations/EmailInvite.vue';
import LinkInvite from '@/components/Invitations/LinkInvite.vue';
import OverviewInvite from '@/components/Invitations/OverviewInvite.vue';

export default {
  name: 'Invite',

  data() {
    return {
      currentTabComponent: 'app-email-invite',
    };
  },

  components: {
    'app-email-invite': EmailInvite,
    'app-link-invite': LinkInvite,
    'app-overview-invite': OverviewInvite,
  },

  methods: {
    toggleTab(tab) {
      switch (tab) {
        case 0:
          this.currentTabComponent = 'app-email-invite';
          break;

        case 1:
          this.currentTabComponent = 'app-link-invite';
          break;

        case 2:
          this.currentTabComponent = 'app-overview-invite';
          break;

        default:
          this.currentTabComponent = 'app-email-invite';
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/styles/colors.scss';
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: top;
}

.modal-container {
  border: 1px solid$primary;

  .nav-bar {
    text-align: left;
    .btn {
      padding: 0.1rem;
    }
  }

  .btn-custom {
    width: 78px !important;
  }
}

.modal-container {
  width: 900px;
  margin: 0px auto;
  margin-top: 50px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header {
  background-color: $primary;
  border-top-left-radius: 0rem;
  border-top-right-radius: 0rem;
}
.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 5px 0;
  padding: 0.1rem;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
